<template>
  <div>
    <router-link :to="{ name: 'MusicNew' }" class="btn btn-success">Create</router-link>

    <div v-if="musics">
      <table class="table">
        <thead>
          <tr>
            <td scope="col">Artist</td>
            <td scope="col">Album</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="music in musics" :key="music.id" :id="music.id">
            <td>{{ music.artist }}</td>
            <td>{{ music.album }}</td>
            <td>
              <div class="btn-group float-right">
                <router-link :to="{ name: 'MusicShow', params: { id: music.id } }" class="btn btn-secondary">Show</router-link>
                <router-link :to="{ name: 'MusicEdit', params: { id: music.id } }" class="btn btn-warning">Edit</router-link>
                <button class="btn btn-danger" v-on:click="destroyMusic(music.id)">Destroy</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else>
      There's actually nothing here.
    </div>
  </div>
</template>

<script>

import { MusicService } from '@/common/services/music.service';

export default {
	name: 'MusicIndex',
	components: {

	},
	data() {
		return {
			musics: null,
		};
	},
	created() {
    this.getMusics();
	},
	methods: {
    getMusics() {
      MusicService.query().then((response) => {
        this.musics = response.data;
      });
    },
    destroyMusic(id) {
      MusicService.destroy(id).then((response) => {
        this.getMusics();
      });
    },
	},
};

</script>

<style lang="scss" scoped>

</style>
